// extracted by mini-css-extract-plugin
module.exports = {"albums-container":"Albums_albums-container__1tH5J","no-albums-container":"Albums_no-albums-container__3RG_M","no-albums-text":"Albums_no-albums-text__IoFZz"};